import { Routes } from '@angular/router';

export const excelRoutes: Routes = [
  {
        path: '',
        loadComponent: () =>
          import('../features/excel-designer/pages/template-list-page/template-list-page.component')
            .then((m) => m.TemplateListPageComponent),
      },
      {
        path: 'designer',
        loadComponent: () =>
          import('../features/excel-designer/pages/template-designer-page/template-designer-page.component')
            .then((m) => m.TemplateDesignerPageComponent),
      },
      {
        path: 'detail',
        loadComponent: () =>
          import('../features/excel-designer/pages/template-designer-page/template-designer-page.component')
            .then((m) => m.TemplateDesignerPageComponent),
      },
      {
        path: 'versions',
        loadComponent: () =>
          import('../features/excel-designer/pages/template-version-page/template-version-page.component')
            .then((m) => m.TemplateVersionPageComponent),
      },
      {
        path: 'version/detail',
        loadComponent: () =>
          import('../features/excel-designer/pages/template-version-detail-page/template-version-detail-page.component')
            .then((m) => m.TemplateVersionDetailPageComponent),
      },
      {
        path: 'assign-units',
        loadComponent: () =>
          import('../features/excel-designer/pages/template-assign-units-page/template-assign-units-page.component')
            .then((m) => m.TemplateAssignUnitsPageComponent),
      },
]